export default __webpack_public_path__ + "static/media/Community.687d0670.jpg";